import {isEmpty} from 'lodash';

const CONFIGURATION_CONFIG = 'config';
const CONFIGURATION_GENERAL = 'general';

const GENERAL_SHOW_PDF = 'showPDF';
const GENERAL_HEADER_LABEL = 'headerLabel';
const GENERAL_COMPANY_NAME = 'companyName';

/** @deprecated */
export class ProjectConfig {
  constructor(rawData = {}) {
    this.rawData = {...rawData};
    this.loaded = !isEmpty(this.rawData);
  }

  getGeneral() {
    return this.rawData[CONFIGURATION_CONFIG]
      ? this.rawData[CONFIGURATION_CONFIG][CONFIGURATION_GENERAL]
      : null;
  }

  getShowPDF() {
    return this.getGeneral() ? this.getGeneral()[GENERAL_SHOW_PDF] : true;
  }

  getHeaderLabel() {
    return this.getGeneral() ? this.getGeneral()[GENERAL_HEADER_LABEL] : '';
  }

  getCompanyName() {
    return this.getGeneral() ? this.getGeneral()[GENERAL_COMPANY_NAME] : '';
  }

  isLoaded() {
    return this.loaded;
  }
}

export default {ProjectConfig};
